import { capacitorOrigin } from './use-capacitor-origin'

const DEVICE_CREATED = 'DEVICE_CREATED'
const SHOW_QR_CODE = 'SHOW_QR_CODE'
const SIGN_OUT = 'SIGN_OUT'
const MOBILE_ACCESS_TOKEN_UNAUTHORIZED = 'MOBILE_ACCESS_TOKEN_UNAUTHORIZED'

export function postDeviceCreated(
    deviceKey: string,
    customerId: string,
    customerName: string
) {
    if (capacitorOrigin.value === null) {
        alert('Oops! We are having internal communication troubles')
        return
    }

    window.parent.postMessage(
        {
            action: DEVICE_CREATED,
            deviceKey: deviceKey,
            customerId: customerId,
            customerName: customerName
        },
        capacitorOrigin.value
    )
}

export function postShowQrCode() {
    if (capacitorOrigin.value === null) {
        alert('Oops! We are having internal communication troubles')
        return
    }

    window.parent.postMessage(
        {
            action: SHOW_QR_CODE
        },
        capacitorOrigin.value
    )
}

export function postSignOut() {
    if (capacitorOrigin.value === null) {
        alert('Oops! We are having internal communication troubles')
        return
    }

    window.parent.postMessage(
        {
            action: SIGN_OUT
        },
        capacitorOrigin.value
    )
}

export function postMobileAccessTokenUnauthorized() {
    if (capacitorOrigin.value === null) {
        alert('Oops! We are having internal communication troubles')
        return
    }

    window.parent.postMessage(
        {
            action: MOBILE_ACCESS_TOKEN_UNAUTHORIZED
        },
        capacitorOrigin.value
    )
}
